module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 text-left"
  }, [(_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.roleType !== 10) ? _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 品牌 ==")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                " + _vm._s(brand.label) + "\n              ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 0 && _vm.brandSelect !== '0' && _vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "form-group form-inline w-auto"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("== 店家 ==")]), _vm._v(" "), _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                " + _vm._s(store.label) + "\n              ")])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: " col-xs-12 col-sm-6 text-right pull-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right w-short"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search2"
    },
    on: {
      "click": function($event) {
        return _vm.clickSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("訂單狀態轉移"), ((_vm.brandSelect === 0 || _vm.brandSelect === '0') && _vm.roleType === 99) ? _c('span', {
    staticClass: "text-red text-12"
  }, [_vm._v("(請選擇品牌或店家)")]) : _vm._e()]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "box-body p-0 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "overflow": "scroll",
      "max-height": "500px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.transitTimeList), function(transitTime, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [(transitTime.date) ? _c('td', {
      attrs: {
        "rowspan": transitTime.reasonAmount
      }
    }, [_vm._v(_vm._s(_vm.getMonthDay(transitTime.date)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTimeString(transitTime.order_create_mean)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTimeString(transitTime.order_reply_mean)))]), _vm._v(" "), _c('td', [(transitTime.order_create_count) ? _c('span', [_vm._v(_vm._s(transitTime.order_create_count))]) : _vm._e()])])
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "th-fit"
  }, [_vm._v("日期")]), _vm._v(" "), _c('th', [_vm._v("購物車 > 送出訂單")]), _vm._v(" "), _c('th', [_vm._v("送出訂單 > 店家接/拒單")]), _vm._v(" "), _c('th', [_vm._v("樣本數")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31d1033a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dash/RejectReason.vue
// module id = 2377
// module chunks = 1